"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Fetch with credentials
 * @param kInstance
 * @param input
 * @param init
 */
exports.fetchWithCredentials = (kInstance, input, init) => __awaiter(void 0, void 0, void 0, function* () {
    if (!kInstance.authenticated) {
        console.error('Fail fetchWithCredentials, user must be authenticated.');
        return { fetchPromise: fetch(input, init), updatedKInstance: undefined };
    }
    return new Promise((resolve, reject) => {
        kInstance.updateToken(10)
            .success((refreshed) => {
            const requestHeaders = init ? init.headers : undefined;
            const credentialInit = Object.assign(Object.assign({}, init), { headers: Object.assign({ Authorization: `Bearer ${kInstance.token}` }, requestHeaders) });
            resolve({ fetchPromise: fetch(input, credentialInit), updatedKInstance: refreshed && kInstance });
        })
            .error(() => {
            console.error('Fail fetchWithCredentials, failed to refresh the token, or the session has expired');
            kInstance.clearToken();
            reject({ fetchPromise: fetch(input, init) });
        });
    });
});
//# sourceMappingURL=fetch.service.js.map